import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { ClosingCreateDataRequest } from "gen/model/closingCreateDataRequest";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import Form from "shared/components/form/Form";
import { FormDateInput } from "shared/components/input/date/DateInput";
import { nowAsIsoDate } from "shared/utils/DateUtils";

export interface CreateClosingProps {
  fundFamilyId: string;
  createClosing(data: ClosingCreateDataRequest): void;
  onCloseComplete(): void;
}

export const CreateClosingModal: React.FC<CreateClosingProps> = ({
  fundFamilyId,
  createClosing,
  onCloseComplete,
}) => {
  const { t } = useTranslation(["closing", "common"]);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const form = useForm<ClosingCreateDataRequest>({
    defaultValues: {
      fund_family_id: fundFamilyId,
      closing_date: nowAsIsoDate(),
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <Form form={form} onSubmit={createClosing} onSuccess={onClose}>
          <ModalHeader>
            {t("closing:createClosing")}
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody>
            <FormDateInput
              name="closing_date"
              title={t("closing:editDateModal.dateInputTitle")}
            />
          </ModalBody>
          <ModalFooter gap={2}>
            <ButtonOrder
              dismiss={<FormCancelButton onClick={onClose} autoFocus={true} />}
              confirm={
                <FormSubmitButton>{t("common:submit")}</FormSubmitButton>
              }
            />
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  );
};
